import React, { useCallback, useState } from 'react';
import { Platform, View } from 'react-native';
import Text, { styles } from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { MoneyTextInput } from 'utils/packages/moneyInput';
import { isWeb } from '../../../../constants';
import ItemBadgeWrapper from './ItemBadgeWrapper';
import IconAmountUpper from './icons/toolbar/IconAmountUpper';
const AmountUpperItemBadge = ({ filter, scrollY, onPress, cancelEdit, handleClose, scrollToItem, isActiveKeyboard, amountUpperValue, refAmountUpperInput, onChangeAmountUpper, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const [inputWidth, setInputWidth] = useState(5 + amountUpperValue.length * 8);
    const onChange = useCallback((text) => {
        onChangeAmountUpper?.(text);
        if (isWeb && text) {
            setInputWidth(5 + text.length * 8);
        }
    }, [onChangeAmountUpper]);
    return (<ItemBadgeWrapper scrollY={scrollY} onCancel={handleClose} handlePress={onPress} scrollToItem={scrollToItem} isActiveKeyboard={isActiveKeyboard}>
      <IconAmountUpper gradientKey="turquoise" width={16} height={16}/>
      <View style={styles.container}>
        <Text Text-14>{filter.badgeText}</Text>
        <View pointerEvents="none">
          <MoneyTextInput autoFocus maximumFractionalDigits={0} maximumIntegerDigits={9} onFocus={cancelEdit} pointerEvents="none" ref={refAmountUpperInput} value={amountUpperValue.replace(/,/g, '')} onChangeText={onChange} style={[styles.badgeInputText, isWeb && { width: inputWidth }]} selectionColor={colors.text.selection}/>
        </View>
      </View>
    </ItemBadgeWrapper>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    badgeInputText: {
        padding: 0,
        ...styles.Numbers_14,
        lineHeight: undefined,
        color: colors.text.primary,
        ...Platform.select({
            web: {
                outlineStyle: 'none',
                caretColor: colors.text.selection,
            },
        }),
    },
}));
export default AmountUpperItemBadge;
